/**
 * Autogenerated file don't modify
 *
 * Generated on: 2020-06-02T15:57:52.524Z
 * Generated by: arnar
 */
(function () {
(function () {
	'use strict';

	site.multiselect = {
		init: function(selector) {
			$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
			$(selector).multiselect({
				sortable: true,
				searchable: true,
			});
		},
	};

}());
typeof tsBuild === 'function' && tsBuild();})();
